/* eslint-disable react/require-default-props */
import React from 'react';
import {Platform, View} from 'react-native';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';

type StaticFocusableProps = {
  children: React.ReactNode;
  label: string;
  testID?: string;
  style?: any;
  role?: 'text' | 'header' | 'alert' | 'image' | 'button';
  state?: Record<string, boolean>;
  importantForAccessibility?: 'auto' | 'yes' | 'no' | 'no-hide-descendants';
};

export const StaticFocusable = ({
  children,
  label,
  testID,
  style,
  role = 'text',
  state = undefined,
  importantForAccessibility,
}: StaticFocusableProps) => {
  const props = {
    testID,
    accessible: true,
    focusable: true,
    accessibilityRole: role,
    accessibilityLabel: label,
    accessibilityState: state,
    importantForAccessibility,
    style,
  };

  if (Platform.OS === 'android' || Platform.OS === 'web') {
    return <View {...props}>{children}</View>;
  }

  return <KeyboardFocusable {...props}>{children}</KeyboardFocusable>;
};
